package fr.frux.core.database

import kotlin.Long
import kotlin.String

public data class Species_cache(
  public val id: Long,
  public val etag: String?,
  public val payload: String,
  public val cached_at: Long,
)
